import { buildTgssFile } from './buildTgssFiocData';
import { keyAndValueOrNull } from '../utilities/objectHelpers';
import { Promise } from 'es6-promise';
import apiURLBuilder from 'core/apiURLBuilder';
import Api from 'services/api';

const sendConsentsService = (dispatch, data, accessToken, callback) => {
    return new Promise(() => {
        Api.post(apiURLBuilder.getURL('consents'), {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        }).then(
            () => {
                callback(true);
            },
            error => {
                callback(false, error);
            }
        );
    });
};

const sendConsents = (accessToken, data, callback) => {
    return dispatch => {
        sendConsentsService(dispatch, data, accessToken, callback);
    };
};

const sendFiocTgssConsent = (accessToken, callback) => (dispatch, getState) => {
    const isTgssCheckSelected = Boolean(getState().userProfile.fiocTgssConsent);

    Api.post(apiURLBuilder.getURL('consentsFiocTgss'), {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {
            ...keyAndValueOrNull({
                key: 'documentation',
                value: dispatch(buildTgssFile()),
                condition: isTgssCheckSelected,
            }),
        },
    }).then(
        () => {
            callback(true);
        },
        error => {
            callback(false, error);
        }
    );
};

export default {
    sendConsents,
    sendFiocTgssConsent,
};
